import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  name: `UserName`
};

export function useUserStyles(allowEdit: boolean) {
  const { spacing, semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      name: [
        classNames.name,
        {
          paddingLeft: spacing.m,
          cursor: allowEdit ? `pointer` : `inerhit`,
          selectors: {
            ":hover > span": {
              color: allowEdit ? semanticColors.primaryButtonBackground : `inerhit`
            }
          }
        }
      ]
    }),
    [spacing, semanticColors, allowEdit]
  );
}
